  import methodAPI from "../Dashboard/Handlers/methodAPI";

  export const adminCategoryAPI = {
    list: async () => {
      return await methodAPI.get('/categories_list');
    },
    create: async (data) => {
      return await methodAPI.post('/categories_create', data);
    },
    edit: async (id,data) => {
      return await methodAPI.post(`/categories_edit/${id}`, data);
    },
    delete: async (id) => {
      return await methodAPI.delete(`/categories_delete/${id}`);
    }
  }
